import { getPortalId } from '../../../utils/getPortalId';
const isPortalIdAvailable = () => getPortalId() !== undefined;
const getAutoOpenKey = () => `in-app-help-auto-open-widget:${getPortalId()}`;
export const runAutoOpen = callback => {
  if (!isPortalIdAvailable()) {
    return;
  }
  let expires = 0;
  try {
    const expiresStr = localStorage.getItem(getAutoOpenKey());
    if (!expiresStr) {
      return;
    }
    expires = parseInt(expiresStr, 10);
  } finally {
    if (Date.now() < expires) {
      setTimeout(callback);
    }
  }
};
export const clearAutoOpen = () => {
  if (!isPortalIdAvailable()) {
    return;
  }
  try {
    localStorage.removeItem(getAutoOpenKey());
  } catch (e) {
    // ignore
  }
};
export const setAutoOpen = () => {
  if (!isPortalIdAvailable()) {
    return;
  }
  try {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    localStorage.setItem(getAutoOpenKey(), tomorrow.getTime().toString());
  } catch (e) {
    // ignore
  }
};